define('presentation/welcome/viewModels/onboardingHeaderViewModel',[
        'common/promises/promiseFactory',
        'presentation/welcome/common/onboardingPageIndicatorWidget'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const _indicatorWidget = require('presentation/welcome/common/onboardingPageIndicatorWidget');

            let _disposables = [];

            self.isPageIndicatorVisible = ko.observable(false);

            self.headingText = ko.observable('');
            self.subtitleText = ko.observable('');

            self.showHeading = ko.pureComputed(() => self.headingText() !== '');
            self.showSubtitle = ko.pureComputed(() => self.subtitleText() !== '');

            self.detached = () => {
                _disposables.forEach(subscription => subscription.dispose());
                _disposables = [];
            };

            self.activate = (data) => {
                const setSelfValue = (name) => {
                    const value = data && data[name];
                    if (value === undefined || value === null) {
                        return;
                    }
                    if (ko.isObservable(value)) {
                        self[name](value());
                        _disposables.push(value.subscribe(self[name]));
                    } else {
                        self[name](value);
                    }
                };
                setSelfValue('headingText');
                setSelfValue('subtitleText');

                return _initialize();
            };

            const _initialize = () => {
                self.isPageIndicatorVisible(_indicatorWidget.getStepState().isVisible);

                _promiseFactory.wait();
            };
        };
    });

